import { defineCustomElements } from '@ionic/pwa-elements/loader';
import ReactDOM from 'react-dom';

import App from './App';
import { AppContextProvider } from './providers/AppContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


// import AutoUpdater from './components/AutoUpdater';

ReactDOM.render(
  <div>
    <AppContextProvider>
      <App />
      {/* <AutoUpdater /> */}
    </AppContextProvider>
  </div>,
  document.getElementById('root')
);

// Call the element loader after the app has been rendered the first time
defineCustomElements(window);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
